import React from 'react';
import { Trans } from 'react-i18next';

import { Box } from 'src/components/Box';
import { Button } from 'src/components/Button';
import { Typography } from 'src/components/Typography';
import { BUTTON_COLOR, BUTTON_SIZE, BUTTON_VARIANT } from 'src/components/Button/types';
import { TYPOGRAPHY_COLORS, TYPOGRAPHY_WEIGHT } from 'src/components/Typography/types';
import { DashboardLayout } from 'src/components/layouts/LayoutContainers/DashboardLayout';
import { EmptyJobViewProps } from './EmptyJobView.types';

export const EmptyJobView: React.FC<EmptyJobViewProps> = ({ onCreateJob }) => {
  return (
    <DashboardLayout>
      <Box mb={1}>
        <Typography variant="h5" fontWeight={TYPOGRAPHY_WEIGHT.MEDIUM}>
          <Trans>jobPage.title</Trans>
        </Typography>
        <Typography
          variant="button"
          color={TYPOGRAPHY_COLORS.TEXT}
          fontWeight={TYPOGRAPHY_WEIGHT.MEDIUM}>
          <Trans>jobPage.cta</Trans>
        </Typography>
      </Box>
      <Box mb={2}>
        <Button
          variant={BUTTON_VARIANT.GRADIENT}
          size={BUTTON_SIZE.SMALL}
          color={BUTTON_COLOR.INFO}
          onClick={onCreateJob}>
          <Trans>jobPage.createJob</Trans>
        </Button>
      </Box>
    </DashboardLayout>
  );
};
